module.exports = __webpack_public_path__ + "static/akpp-22362540363f4de1f3328a9d6c2cd10f.webp";